import * as Sentry from '@sentry/react';

declare global {
  interface Window {
    proxy?: any;
  }
}
export function initSentry() {
  try {
    // 检查是否存在 proxy 支持
    if (window.proxy || typeof Proxy !== 'undefined') {
      // 初始化 Sentry
      Sentry.init({
        dsn: 'https://1984794e7e37e01605b7ab01406c8737@sty.yuaiweiwu.com/61',
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        denyUrls: [/http:\/\/localhost(?::\d+)?/, /aienglish-live\.(dev|test)\.aitutor100\.com/],
        // denyUrls: [/http:\/\/localhost(?::\d+)?/],

        // Performance Monitoring
        tracesSampleRate: 0.8, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: [],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      });
      console.log('Sentry initialized successfully');
    } else {
      console.warn('Proxy not supported, skipping Sentry initialization');
    }
  } catch (error) {
    console.warn('Sentry initialization failed:', error);
  }
}